export const compressionCodecType = {
    none: 'none',
    bzip2: 'bzip2',
    bz2: 'bz2', // for parquetV2 & delta
    brotli: 'brotli',
    gzip: 'gzip',
    deflate: 'deflate',
    snappy: 'snappy',
    lzo: 'lzo',
    lz4: 'lz4',
    lz4frame: 'lz4frame',
    lz4hadoop: 'lz4hadoop',
    ZipDeflate: 'ZipDeflate',
    xz: 'xz',
    zlib: 'zlib',
    TarGZip: 'TarGZip',
    tar: 'tar',
    zstd: 'zstd'
};

export const compressionCodecTypeLabel = {
    none: 'none',
    bzip2: 'bzip2 (.bz2)',
    bz2: 'bzip2 (.bz2)',
    brotli: 'Brotli (.br)',
    gzip: 'gzip (.gz)',
    deflate: 'deflate (.deflate)',
    snappy: 'snappy',
    lzo: 'lzo',
    lz4: 'lz4',
    lz4frame: 'lz4frame',
    lz4hadoop: 'lz4hadoop',
    ZipDeflate: 'ZipDeflate (.zip)',
    xz: 'xz (.xz)',
    zlib: 'zlib (.zlib)',
    TarGZip: 'TarGZip (.tgz/.tar.gz)',
    tar: 'tar (.tar)',
    zstd: 'Zstandard'
};

export enum Encoding {
    UTF_7 = 'UTF-7',
    UTF_8 = 'UTF-8',
    UTF_8_WITHOUT_BOM = 'UTF-8 without BOM',
    UTF_16 = 'UTF-16',
    UTF_16LE = 'UTF-16LE',
    UTF_16BE = 'UTF-16BE',
    UTF_32 = 'UTF-32',
    UTF_32LE = 'UTF-32LE',
    UTF_32BE = 'UTF-32BE',
    US_ASCII = 'US-ASCII',
    BIG5 = 'BIG5',
    EUC_JP = 'EUC-JP',
    EUC_KR = 'EUC-KR',
    GB2312 = 'GB2312',
    GB18030 = 'GB18030',
    JOHAB = 'JOHAB',
    SHIFT_JIS = 'SHIFT-JIS',
    CP875 = 'CP875',
    CP866 = 'CP866',
    IBM00858 = 'IBM00858',
    IBM037 = 'IBM037',
    IBM273 = 'IBM273',
    IBM437 = 'IBM437',
    IBM500 = 'IBM500',
    IBM737 = 'IBM737',
    IBM775 = 'IBM775',
    IBM850 = 'IBM850',
    IBM852 = 'IBM852',
    IBM855 = 'IBM855',
    IBM857 = 'IBM857',
    IBM860 = 'IBM860',
    IBM861 = 'IBM861',
    IBM863 = 'IBM863',
    IBM864 = 'IBM864',
    IBM865 = 'IBM865',
    IBM869 = 'IBM869',
    IBM870 = 'IBM870',
    IBM01140 = 'IBM01140',
    IBM01141 = 'IBM01141',
    IBM01142 = 'IBM01142',
    IBM01143 = 'IBM01143',
    IBM01144 = 'IBM01144',
    IBM01145 = 'IBM01145',
    IBM01146 = 'IBM01146',
    IBM01147 = 'IBM01147',
    IBM01148 = 'IBM01148',
    IBM01149 = 'IBM01149',
    ISO_2022_JP = 'ISO-2022-JP',
    ISO_2022_KR = 'ISO-2022-KR',
    ISO_8859_1 = 'ISO-8859-1',
    ISO_8859_2 = 'ISO-8859-2',
    ISO_8859_3 = 'ISO-8859-3',
    ISO_8859_4 = 'ISO-8859-4',
    ISO_8859_5 = 'ISO-8859-5',
    ISO_8859_6 = 'ISO-8859-6',
    ISO_8859_7 = 'ISO-8859-7',
    ISO_8859_8 = 'ISO-8859-8',
    ISO_8859_9 = 'ISO-8859-9',
    ISO_8859_13 = 'ISO-8859-13',
    ISO_8859_15 = 'ISO-8859-15',
    WINDOWS_874 = 'WINDOWS-874',
    WINDOWS_1250 = 'WINDOWS-1250',
    WINDOWS_1251 = 'WINDOWS-1251',
    WINDOWS_1252 = 'WINDOWS-1252',
    WINDOWS_1253 = 'WINDOWS-1253',
    WINDOWS_1254 = 'WINDOWS-1254',
    WINDOWS_1255 = 'WINDOWS-1255',
    WINDOWS_1256 = 'WINDOWS-1256',
    WINDOWS_1257 = 'WINDOWS-1257',
    WINDOWS_1258 = 'WINDOWS-1258'
}

export const snowflakeSupportedDelimitedSourceEncodingName: string[] = [
    Encoding.UTF_8,
    Encoding.UTF_16,
    Encoding.UTF_16BE,
    Encoding.UTF_32,
    Encoding.UTF_32BE,
    Encoding.BIG5,
    Encoding.EUC_JP,
    Encoding.EUC_KR,
    Encoding.GB18030,
    Encoding.ISO_2022_JP,
    Encoding.ISO_2022_KR,
    Encoding.ISO_8859_1,
    Encoding.ISO_8859_2,
    Encoding.ISO_8859_5,
    Encoding.ISO_8859_6,
    Encoding.ISO_8859_7,
    Encoding.ISO_8859_8,
    Encoding.ISO_8859_9,
    Encoding.WINDOWS_1250,
    Encoding.WINDOWS_1251,
    Encoding.WINDOWS_1252,
    Encoding.WINDOWS_1253,
    Encoding.WINDOWS_1254,
    Encoding.WINDOWS_1255
];

export const snowflakeSupportedJSONSourceEncodingName: string[] = [
    Encoding.UTF_8
];

export const snowflakeSupportedSinkEncodingName: string[] = [
    Encoding.UTF_8
];

export type SalesforceSourceOptionEnum = 'objectApiName' | 'reportId';